import type { PaginationMeta } from '@amarantos/api-client'

/**
 * The schema's `per_page` ceiling (ADR 0013), asked for by every list a screen renders whole rather
 * than pages through. It is a domain-size ceiling, not a tuning knob: a collection that reaches it
 * needs a fetch-all loop, which is what `findWholeListShortfall` is here to catch.
 */
export const WHOLE_LIST_PER_PAGE = 1000

export interface WholeListPage<T> {
	data: T[]
	meta: PaginationMeta
}

export interface WholeListShortfall {
	received: number
	totalCount: number
}

export function findWholeListShortfall(page: WholeListPage<unknown>): WholeListShortfall | null {
	const received = page.data.length
	const totalCount = page.meta.total_count

	if (received >= totalCount) {
		return null
	}

	return { received, totalCount }
}
